import React from "react";

const CircleIcon = ({ width = "18", height = "18" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 18 18">
      <path fill="none" d="M0 0h18v18H0z" />
      <circle cx="9" cy="9" r="7.5" stroke="#DA2D2D" strokeWidth="3" />
    </svg>
  );
};

export default CircleIcon;
